import request from "_private/utils/request";

//获取area数据
export function fetchAreaDatas_Api() {
  const dataArr = [];
  return new Promise((resolve, reject) => {
    fetchAreas({
      params: { pageParamVO: { curPage: 1, pageSize: 500 } },
      resolve,
      reject,
      dataArr
    });
  });
}
const fetchAreas = function(opts) {
  return request({
    url: `/monitorCenter/logisticsMap/getArea`,
    method: "post",
    headers: { type: "json" },
    data: opts.params
  }).then(res => {
    if (res.code == 1 && res.result && Array.isArray(res.result.data)) {
      opts.dataArr = [...opts.dataArr, ...res.result.data];
      if (opts.dataArr.length < res.result.totalRecords) {
        // 数据未请求完，继续请求
        opts.params.pageParamVO.curPage++;
        fetchAreas(opts);
      } else {
        opts.resolve(opts.dataArr);
      }
    }
  });
};
// 保存area
export function saveArea_Api(params) {
  return request({
    url: `/monitorCenter/logisticsMap/saveOrEditArea`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
}
// 删除area
export function deleteMarkers_Api(params) {
  return request({
    url: `/monitorCenter/logisticsMap/delPointArea`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
}
export function getXzAreaInfoByCity(params) {
  return request({
    url: `/monitorCenter/logisticsMap/getDiAreaCodeByBin`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
}
//拖拽地图后获取中心城市
export function fetchCityByLonLat(params) {
  return request({
    url: `/monitorCenter/logisticsMap/getCity`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
}
//新增普通区域拉框后自动获取地理位置
export function fetchPositionByLonLat(params) {
  return request({
    url: `/monitorCenter/logisticsMap/geoInfo`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
}
// 保存area
export function exportCustomArea(data) {
  console.log(data);
  return request({
    url: `/monitorCenter/logisticsMap/exportCustomArea`,
    method: "post",
    headers: { type: "json" },
    responseType: "blob",
    data: data
  });
}
